/**
 * Created by vxg on 2019/07/11.
 */
import request from '../utils/request'
//const serviceName = 'api'

export function getCategoryTreeByKey(key) {
  return request({
    url: `/category/getCategoryTreeByKey?key=${key}&t=` + new Date().getTime(),
    method:'get'
  })
}

export function getCategoryList(key,value) {
  return request({
    url:`/category/getCategoryList/${key}?value=${value}&t=` + new Date().getTime(),
    method:'get'
  })
}

export function delCategory(id) {
  return request({
    url:`/category/delCategory?id=${id}&t=` + new Date().getTime(),
    method:'get'
  })
}

export function addCategory(jsonData) {
  return request({
    url:`/category/addCategory`,
    method:'post',
    data:jsonData
  })
}



// WEBPACK FOOTER //
// ./src/api/category.js